import { createVanIconComponent } from "./van"

const Fire = createVanIconComponent("fire")
export default Fire
